import {
  createPanelFrame,
  resolveTitle,
  createMetric,
  formatNumber,
  formatPercent,
  toNumber
} from './panel-utils.js';

const DEFAULT_ITEMS = Array.from({ length: 8 }, (_, i) => ({
  id: `asset-${i + 1}`,
  src: `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="160" height="100"><rect width="100%25" height="100%25" fill="%23091c2d"/><rect x="10" y="10" width="140" height="80" fill="none" stroke="%235feaff" stroke-width="2"/><text x="50%25" y="50%25" fill="%235feaff" font-size="14" font-family="monospace" text-anchor="middle">ASSET ${i + 1}</text></svg>`,
  label: i % 3 === 0 ? 'anomaly' : 'ok',
  score: 0.35 + (i % 5) * 0.12
}));

export function render({ node, api }) {
  const { root, body, titleEl, metaEl } = createPanelFrame(node, 'Media Batch Inspector');
  const metrics = document.createElement('div');
  metrics.className = 'ew-metric-grid';

  const grid = document.createElement('div');
  grid.className = 'ew-media-grid';

  body.append(metrics, grid);

  const update = (next) => {
    titleEl.textContent = resolveTitle(next, 'Media Batch Inspector');
    const items = Array.isArray(next?.data?.items || next?.props?.items)
      ? (next.data?.items || next.props?.items)
      : DEFAULT_ITEMS;
    const selected = next?.data?.selected;
    const avgScore = items.length
      ? items.reduce((acc, item) => acc + toNumber(item.score, 0), 0) / items.length
      : 0;
    const flagged = items.filter((item) => toNumber(item.score, 0) >= 0.7 || item.label === 'anomaly').length;

    metaEl.textContent = `${items.length} assets`;

    metrics.innerHTML = '';
    metrics.append(
      createMetric('items', formatNumber(items.length)),
      createMetric('avg score', formatPercent(avgScore, 0)),
      createMetric('flagged', formatNumber(flagged))
    );

    grid.innerHTML = '';
    items.slice(0, 12).forEach((item) => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'ew-media-card';
      if (selected && selected === item.id) card.classList.add('is-active');

      if (item.src) {
        const img = document.createElement('img');
        img.className = 'ew-media-thumb';
        img.alt = item.label || item.id;
        img.src = item.src;
        card.appendChild(img);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'ew-media-placeholder';
        placeholder.textContent = item.label || item.id;
        card.appendChild(placeholder);
      }

      const meta = document.createElement('div');
      meta.className = 'ew-media-meta';
      meta.textContent = `${item.label || 'asset'} � ${formatPercent(toNumber(item.score, 0), 0)}`;

      card.appendChild(meta);
      card.addEventListener('click', () => {
        api.setData({ selected: item.id });
        api.emit('node:input', { id: node.id, field: 'media', value: item.id });
      });
      grid.appendChild(card);
    });
  };

  update(node);
  return { el: root, update };
}
